var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"no-wx-client-tip"},[_c('div',{staticClass:"content"},[_vm._v("请在微信APP内打开该页面")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }